var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard6D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type5_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M360.4,375.5c-1.4,0-12,0.7-8.5,3.7c1.6,1.4,3.4,2.3,4.9,3.9c0.8,0.8,1.4,1.8,2,2.7 c0.5,0.8,0.2,2.4,1.1,2.7c1.3,0.5,2.9-3.7,3.7-4.8c1.3-1.8,2.7-3,4.2-4.4c2.3-2.1,0.4-2.4-1.7-3 C364.2,375.9,362.4,375.6,360.4,375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M305.1,351.1c1.3,0.2,4.5-1.4,5.7-1.7c2.3-0.8,4.7-1.4,7.1-2c9.1-2.4,17.8-3.6,27.4-2.7 c5.3,0.5,10.5,2.7,15.9,2.5c5.5,0.2,10.6-2,15.9-2.5c9.5-0.9,18.2,0.3,27.4,2.7c2.4,0.6,4.8,1.2,7.1,2c1.1,0.4,4.4,1.9,5.7,1.7 c1.4-0.2-2.4-7-5.6-8.5c-8.2-4-18.6-4-26.9-5.8c-2-0.4-4.3-1.1-6.1-2c-2.4-1.2-2.6-1.3-5-0.3c-4.2,1.8-7.9,2.9-12.6,3 c-4.7-0.2-8.4-1.2-12.6-3c-2.4-1.1-2.5-1-5,0.3c-1.8,0.9-4.1,1.6-6.1,2c-8.3,1.8-18.7,1.8-26.9,5.8 C307.5,344.2,303.7,351,305.1,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M451.7,265.7c-1.7,21.8-2.3,36.6-11.6,55.8c-2.4,6.1-6.6,10.5-11.2,15.2c-2.4,4.1-5,9.5-6.3,14.1 c-2.7,9.6-9.4,15.2-17,20.7c-14.4,10.6-27.6,22-45.3,23.1c-0.5,0-1,0-1.4,0c-0.1,0-0.3,0-0.5,0c-18.5-0.2-31.3-12.5-45.9-23.2 c-7.6-5.6-14.3-11.1-17-20.7c-1.3-4.6-3.9-10-6.3-14.1c-4.6-4.7-8.8-9-11.2-15.2c-9.4-19.2-5.9-35.6-11.5-53.5 c-1.2,11.7-3.2,23.9-2.5,37.2c0.2,3.2,1.2,13.2,1.5,15.7c2.9,13.8,3.2,12.8,8.3,25.5c2.5,6.1,8,13.5,11.6,18.8 c3.7,5.3,6.9,9.2,12.1,15.2c4.6,4,8,8.4,12.6,12.4c5.5,4.8,8.8,7.7,13.3,11.8c10,9.2,55.7,12.3,69.3,1.3c4.3-3.4,11.5-9,16.7-14.3 c4.3-4.4,6.8-7.1,11.2-11.3c5.5-5.3,10.5-12,14.2-17.3s5.9-8.6,8.4-14.7c9.3-22.8,15.1-34.4,9.9-71.3 C452.7,274,452.4,268.9,451.7,265.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard6D);
export default __webpack_public_path__ + "static/media/man_beard_6d.d196ab22c6070fbca7bf4e45230e4233.svg";
export { ForwardRef as ReactComponent };